import React, { useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
import { useGetOrdersQuery } from './orders.api';
import { DateTime } from '../datetime/datetime';
import { IContact, OrderStatus } from '@topshots/core-models';
import { OrderTotal } from './order-total';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Orders = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState<number>(
    searchParams.get('page') ? parseInt(searchParams.get('page') as string) : 1
  );
  const [status, setStatus] = useState<OrderStatus>(
    (searchParams.get('status') as OrderStatus) ?? OrderStatus.Confirmed
  );
  const [perPage, setPerPage] = useState<number>(
    searchParams.get('perPage')
      ? parseInt(searchParams.get('perPage') as string)
      : 100
  );
  const [search] = useState<string | undefined>(undefined);
  const { data, isLoading } = useGetOrdersQuery({
    page,
    perPage,
    status,
    search,
  });

  const navigate = useNavigate();
  const perPageChangeHandler = (selected: number) => {
    const newSearchParams = new URLSearchParams();

    // Copy all existing parameters to the new instance
    searchParams.forEach((value, key) => {
      newSearchParams.set(key, value);
    });

    // Update the page parameter
    newSearchParams.set('perPage', selected.toString());

    // Use setSearchParams to update the query parameters in the URL
    setSearchParams(newSearchParams);
    setPerPage(selected);
  };
  const goToPage = (page: number) => {
    const newSearchParams = new URLSearchParams();

    // Copy all existing parameters to the new instance
    searchParams.forEach((value, key) => {
      newSearchParams.set(key, value);
    });

    // Update the page parameter
    newSearchParams.set('page', page.toString());

    // Use setSearchParams to update the query parameters in the URL
    setSearchParams(newSearchParams);
    setPage(page);
  };
  return (
    <>
      <PageTitle
        title="Orders"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.ORDERS.title, link: Routes.ORDERS.link },
        ]}
      />
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Card>
          <CardContent>
            <FilterBar
              value={{
                status,
              }}
              filters={[
                {
                  key: 'status',
                  title: 'Status',
                  options: [
                    { display: 'Created', value: OrderStatus.Created },
                    { display: 'Complete', value: OrderStatus.Complete },
                    { display: 'Unconfirmed', value: OrderStatus.Unconfirmed },
                    { display: 'Confirmed', value: OrderStatus.Confirmed },
                  ],
                  //default: OrderStatus.Confirmed,
                },
              ]}
              onFilterChanged={(filter, values) => {
                switch (filter.key) {
                  case 'status':
                    setStatus(values as OrderStatus);
                    break;
                }
              }}
              // onSearch={(term) => {
              //   setSearch(term === '' ? undefined : term);
              // }}
            />
          </CardContent>
          <table>
            <thead>
              <tr>
                <th>Created</th>
                <th>Customer name</th>
                <th>Total</th>
                <th>Status</th>
                <th>Paid?</th>
                <th>Refunded?</th>
              </tr>
            </thead>
            <tbody>
              {data?.data.map((o) => (
                <tr
                  onClick={() => {
                    navigate(`${o._id}`);
                  }}
                  key={o._id.toString()}
                >
                  <td>
                    <DateTime d={o.created_on} />
                  </td>
                  <td>{(o.contact_id as IContact)?.full_name ?? ''}</td>
                  <td>
                    <OrderTotal id={o._id.toString()} />
                  </td>
                  <td>{o.status}</td>
                  <td>{o.isPaid ? 'Yes' : 'No'}</td>
                  <td>{o.isRefunded ? 'Yes' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pager
            onNext={() => {
              goToPage(page + 1);
            }}
            onPrevious={() => {
              goToPage(page - 1);
            }}
            onPageSelected={(selected) => {
              goToPage(selected);
            }}
            onPerPageChange={(selected) => {
              perPageChangeHandler(selected);
              goToPage(1);
            }}
            page={page}
            perPage={perPage}
            totalPages={data?.totalPages ?? 1}
          />
        </Card>
      )}
    </>
  );
};
